/* Opt-in programme reminders. The narrow push worker never controls storefront pages. */
(() => {
 'use strict';
 if (window.__asifRadioReminders) return;
 window.__asifRadioReminders = true;
 const BASE = '/apps/asif-forms/radio-notifications';
 const KEY = 'asif.radio.reminder-device.v1';
 let root, dialog, opener, occurrence, programHandle = '', generation = 0, config, registration, preparation;
 let testReceivedAt = 0;
 let items = [], series = [], busy = false, refreshGeneration = 0, enrollmentReady = false;
 const text = key => root?.dataset[key] || '';
 const node = name => root?.querySelector(`[data-reminder-${name}]`);
 const token = create => {
   let value = localStorage.getItem(KEY);
   if (!value && create) {
     value = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
     localStorage.setItem(KEY, value);
   }
   return value;
 };
 const api = async (path, options = {}) => {
   const controller = new AbortController();
   const timeout = setTimeout(() => controller.abort(), 15000);
   try {
     const response = await fetch(BASE + path, { ...options, credentials:'omit', signal:controller.signal,
       headers:{'Content-Type':'application/json', ...(options.auth ? {Authorization:`Bearer ${token(false)}`} : {})} });
     const result = await response.json().catch(() => ({error:response.status >= 500 ? 'push_transport_failed' : 'request'}));
     if (!response.ok) { const error = new Error(result.error?.code || result.error || 'request'); error.providerStatus = result.providerStatus; throw error; }
     return result;
   } finally { clearTimeout(timeout); }
 };
 const activeWorker = reg => new Promise((resolve, reject) => {
   if (reg.active) return resolve(reg);
   const worker = reg.installing || reg.waiting;
   if (!worker) return reject(new Error('worker'));
   const timer = setTimeout(() => { worker.removeEventListener('statechange', change); reject(new Error('worker-timeout')); }, 15000);
   const change = () => {
     if (worker.state === 'activated') { clearTimeout(timer); worker.removeEventListener('statechange', change); resolve(reg); }
     if (worker.state === 'redundant') { clearTimeout(timer); worker.removeEventListener('statechange', change); reject(new Error('worker')); }
   };
   worker.addEventListener('statechange', change); change();
 });
 const supported = () => 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
 const needsInstall = () => (/iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
   && !navigator.standalone && !matchMedia('(display-mode: standalone)').matches;
 const prepare = () => {
   if (!preparation) preparation = (async () => {
     config = await api('/config');
     if (!config.enabled || !config.publicKey) throw new Error('unavailable');
     registration = await activeWorker(await navigator.serviceWorker.register(`${BASE}/sw.js`, {scope:`${BASE}/`, updateViaCache:'none'}));
   })().catch(error => { preparation = null; throw error; });
   return preparation;
 };
 const same = item => occurrence && item.programHandle === occurrence.programHandle && Date.parse(item.startsAt) === Date.parse(occurrence.startsAt) && Date.parse(item.endsAt) === Date.parse(occurrence.endsAt);
 const recurring = () => series.find(item => item.programHandle === programHandle);
 // as.if.club (25.09.2026): Erinnerungen eines Mitglieds liegen auch im Konto
 // und kommen ueber den Club-Server auf alle Geraete mit Push-Freigabe.
 const account = () => { try { return window.AsIfClub?.reminders?.() || null; } catch { return null; } };
 const accountSeries = () => account()?.series.find(item => item.programHandle === programHandle);
 const accountOnce = () => account()?.once.find(same);
 const announce = detail => document.dispatchEvent(new CustomEvent('asif:reminder-change', { detail }));
 const chosenMode = () => node('mode')?.value === 'always' ? 'always' : 'once';
 const sync = () => {
   if (!root || !dialog?.open) return;
   const savedSeries = recurring(), saved = savedSeries || items.find(same);
   const savedMode = savedSeries ? 'always' : 'once', changed = !!saved && chosenMode() !== savedMode;
   const club = account(), clubSaved = !saved && !!(accountSeries() || accountOnce());
   const tooLate = occurrence && Date.parse(occurrence.startsAt) <= Date.now() + 600000;
   const enable = node('enable'), cancel = node('cancel');
   enable.hidden = (!!saved && !changed) || needsInstall() || !supported() || (supported() && Notification.permission === 'denied'); cancel.hidden = !saved || changed;
   if (node('mode')) node('mode').disabled = busy || !enrollmentReady;
   enable.textContent = clubSaved ? (text('enableHere') || 'Auf diesem Gerät einschalten') : text(changed ? 'saveChanges' : 'enable');
   cancel.hidden = !(saved || clubSaved) || changed;
   if (!cancel.dataset.label) cancel.dataset.label = cancel.textContent;
   cancel.textContent = club ? (text('cancelEverywhere') || 'Überall ausschalten') : cancel.dataset.label;
   enable.disabled = busy || !enrollmentReady || (tooLate && chosenMode() === 'once') || !occurrence || !registration || !config || needsInstall() || !supported() || Notification.permission === 'denied';
   cancel.disabled = busy;
   node('calendar').disabled = !occurrence;
   node('install').hidden = !needsInstall();
   if(node('test')) { node('test').hidden = !saved; node('test').disabled = busy; }
   if (saved && !busy && !node('status').textContent) node('status').textContent = text(changed ? 'modeChanged' : savedSeries ? 'activeAlways' : 'active');
   else if (clubSaved && !busy && !node('status').textContent) node('status').textContent = text('clubSaved') || 'Im Club gemerkt. Auf diesem Gerät ist Push noch aus.';
   else if (tooLate && !busy && chosenMode() === 'once' && !saved) node('status').textContent = text('tooLate');
 };
 const decorate = () => {
   document.querySelectorAll('[data-radio-reminder-show]').forEach(button => {
     const club = account() || { series: [], once: [] };
     const matchOnce = item => item.programHandle === button.dataset.radioReminderShow && Date.parse(item.startsAt) > Date.now()
       && (Date.parse(button.dataset.radioReminderStart) <= Date.now() || Date.parse(item.startsAt) === Date.parse(button.dataset.radioReminderStart));
     const saved = series.some(item => item.programHandle === button.dataset.radioReminderShow) || items.some(matchOnce)
       || club.series.some(item => item.programHandle === button.dataset.radioReminderShow) || club.once.some(matchOnce);
     button.classList.toggle('is-saved', saved);
     button.setAttribute('aria-pressed', String(saved));
   });
 };
 document.addEventListener('asif:reminder-ui', decorate);
 const refresh = async () => {
   const request = ++refreshGeneration, owner = token(false);
   if (!owner) { items = []; series = []; decorate(); return; }
   const result = await api('/reminders', {auth:true});
   if (request !== refreshGeneration || owner !== token(false)) return;
   items = result.items || []; series = result.series || []; decorate();
   reportDevice();
 };
 // Geraet mit Push-Freigabe beim Club melden (nur Mitglieder, der Club drosselt
 // auf einmal am Tag). Eigene Erinnerungen von vor dem Club kommen ins Konto.
 const reportDevice = async () => {
   try {
     if (!window.AsIfClub?.isMember?.() || !supported() || Notification.permission !== 'granted' || !token(false)) return;
     const reg = await navigator.serviceWorker.getRegistration(`${BASE}/`);
     const sub = await reg?.pushManager?.getSubscription();
     if (!sub) return;
     document.dispatchEvent(new CustomEvent('asif:reminder-device', { detail: { token: token(false), subscription: sub.toJSON(), merge: { series: series.map(item => ({ programHandle: item.programHandle, title: item.title })), once: items.filter(item => item.mode !== 'always').map(item => ({ programHandle: item.programHandle, startsAt: item.startsAt, endsAt: item.endsAt, title: item.title })) } } }));
   } catch {}
 };
 const findOccurrence = async reference => {
   if (window.AsIfRadioCalendar.canRemember(reference)) return reference;
   const endpoint = document.querySelector('[data-asif-radio-root]')?.dataset.scheduleApi;
   const url = new URL(endpoint); const now = Date.now();
   url.searchParams.set('from', new Date(now).toISOString());
   url.searchParams.set('to', new Date(now + 31 * 86400000).toISOString());
   const controller = new AbortController(), timer = setTimeout(() => controller.abort(),15000);
   try {
     const response = await fetch(url,{signal:controller.signal,credentials:'omit'});
     if (!response.ok || response.headers.get('X-AsIf-Metadata-Stale') === 'true') throw new Error('schedule');
     return window.AsIfRadioCalendar.nextOccurrence((await response.json()).items, reference);
   } finally { clearTimeout(timer); }
 };
 const open = async (reference, button) => {
   if (!dialog) return;
   const current = ++generation;
   opener = button; occurrence = null; programHandle = reference.programHandle || '';
   if (node('mode')) node('mode').value = 'once'; busy = true; enrollmentReady = false;
   node('title').textContent = reference.title;
   node('date').textContent = text('loading');
   node('status').textContent = '';
   if (node('calendar-status')) node('calendar-status').textContent = '';
   if (node('test-status')) node('test-status').textContent = '';
   if (node('details')) node('details').open = false;
   dialog.showModal(); sync();
   try {
     const candidate = await findOccurrence(reference);
     if (current !== generation || !dialog.open) return;
     occurrence = candidate;
     if (!occurrence) {
       node('date').textContent = text('missing'); await refresh();
       if (current === generation && node('mode')) node('mode').value = recurring() || accountSeries() ? 'always' : 'once';
       return;
     }
     node('date').textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'de', {weekday:'short',day:'numeric',month:'short',hour:'2-digit',minute:'2-digit',timeZoneName:'short',timeZone:'Europe/Berlin'}).format(new Date(occurrence.startsAt));
     // Gemerkt im Club: Haeufigkeit so vorwaehlen, wie es im Konto steht.
     if (node('mode') && accountSeries()) node('mode').value = 'always';
     sync();
     const clubNote = (accountSeries() || accountOnce()) && !recurring() && !items.some(same) ? 'Im Club gemerkt, deine anderen Geräte mit Push erinnern dich. ' : '';
     if (needsInstall()) { node('status').textContent = clubNote + text('ios'); return; }
     if (!supported()) { node('status').textContent = clubNote + text('unsupported'); return; }
     if (Notification.permission === 'denied') { node('status').textContent = clubNote + text('denied'); return; }
     await prepare(); await refresh();
     if (current !== generation || !dialog.open) return;
     if (node('mode')) node('mode').value = recurring() || accountSeries() ? 'always' : 'once';
     if (recurring() || items.some(same)) {
       const diagnostic = await api('/test', {auth:true});
       if (current === generation) root.dataset.reminderDiagnostic = diagnostic.lastError || String(diagnostic.lastProviderStatus || 'ready');
     }
     if (current !== generation || !dialog.open) return;
     enrollmentReady = true; node('status').textContent = '';
   } catch (error) { if (current === generation && dialog.open) { node('status').textContent = text('error'); root.dataset.reminderError = error.message || 'unknown'; } }
   finally { if (current === generation) { busy = false; sync(); } }
 };
 const keyBytes = value => Uint8Array.from(atob(value.replace(/-/g,'+').replace(/_/g,'/').padEnd(Math.ceil(value.length/4)*4,'=')), char=>char.charCodeAt(0));
 document.addEventListener('click', async event => {
   const button = event.target.closest('[data-reminder-enable], [data-reminder-cancel], [data-reminder-close], [data-reminder-calendar], [data-reminder-install], [data-reminder-test]');
   if (!button || !root?.contains(button)) return;
   if (button.hasAttribute('data-reminder-close')) { dialog.close(); return; }
   if (button.hasAttribute('data-reminder-install')) {
     dialog.close(); document.querySelector('[data-app-open]:not([hidden])')?.click(); return;
   }
   if (!occurrence && !button.hasAttribute('data-reminder-cancel')) return;
   if (button.hasAttribute('data-reminder-calendar')) {
     let url;
     try {
       url = URL.createObjectURL(new Blob([window.AsIfRadioCalendar.generate(occurrence)],{type:'text/calendar;charset=utf-8'}));
       const link = document.createElement('a'); link.href=url; link.download=`as-if-radio-${occurrence.startsAt.slice(0,10)}.ics`; link.hidden=true;
       root.append(link); link.click(); link.remove(); setTimeout(()=>URL.revokeObjectURL(url),60000);
       (node('calendar-status') || node('status')).textContent=text('calendarSaved');
     } catch (_) { if(url) URL.revokeObjectURL(url); (node('calendar-status') || node('status')).textContent=text('error'); }
     return;
   }
   if (busy) return;
   const current = generation, selected = {...occurrence}, mode = chosenMode(), selectedSeries = recurring(), testing = button.hasAttribute('data-reminder-test'), testStartedAt = Date.now();
   if (testing && node('test-status')) node('test-status').textContent = text('testSending');
   busy = true; node('status').textContent = ''; sync();
   try {
     if (button.hasAttribute('data-reminder-test')) {
       await api('/test',{method:'POST',auth:true});
       if(current===generation) (node('test-status') || node('status')).textContent=text(testReceivedAt >= testStartedAt ? 'testReceived' : 'testSent');
     } else if (button.hasAttribute('data-reminder-cancel')) {
       const saved=items.find(same), clubSeries=accountSeries(), clubOnce=accountOnce();
       if (selectedSeries && token(false)) await api(`/series/${encodeURIComponent(selectedSeries.programHandle)}`,{method:'DELETE',auth:true});
       else if(saved && token(false)) await api(`/reminders/${encodeURIComponent(saved.id)}`,{method:'DELETE',auth:true});
       const cancelSeries = selectedSeries || clubSeries, cancelOnce = saved || clubOnce;
       if (cancelSeries || cancelOnce) announce({ action:'cancel', mode: cancelSeries ? 'always' : 'once', programHandle, occurrence: cancelOnce ? { programHandle: cancelOnce.programHandle, startsAt: cancelOnce.startsAt, endsAt: cancelOnce.endsAt } : null });
       if (current === generation && node('test-status')) node('test-status').textContent = '';
       await refresh(); if(current===generation) node('status').textContent=text('cancelled');
     } else {
       if(mode === 'once' && Date.parse(selected.startsAt) <= Date.now() + 600000) { node('status').textContent=text('tooLate'); return; }
       // Permission is requested directly within this explicit user activation.
       const permission = await Notification.requestPermission();
       if(permission !== 'granted') { if(current===generation) node('status').textContent=text(permission==='denied'?'denied':'notGranted'); return; }
       if(current!==generation || !dialog.open) return;
       const freshDevice = !token(false);
       if(freshDevice) localStorage.setItem(`${KEY}.reset`, '1');
       token(true);
       let subscription = await registration.pushManager.getSubscription();
       if(current!==generation || !dialog.open) return;
       // Audit 24.09.: Abo mit altem Schluessel (VAPID gewechselt) ist tot, neu anlegen.
       const sameKey = sub => { try { const k = sub?.options?.applicationServerKey; if(!k) return true; const a = new Uint8Array(k), b = keyBytes(config.publicKey); return a.length===b.length && a.every((v,i)=>v===b[i]); } catch { return true; } };
       if(localStorage.getItem(`${KEY}.reset`) || (subscription && !sameKey(subscription))) {
         if(subscription && !(await subscription.unsubscribe())) throw new Error('subscription-reset');
         subscription = null;
         localStorage.removeItem(`${KEY}.reset`);
       }
       if(current!==generation || !dialog.open) return;
       if(!subscription) subscription = await registration.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:keyBytes(config.publicKey)});
       if(current!==generation || !dialog.open) return;
       await api('/reminders',{method:'PUT',auth:true,body:JSON.stringify({subscription:subscription.toJSON(),occurrence:selected,mode})});
       announce({ action:'set', mode, programHandle: selected.programHandle, occurrence: { programHandle: selected.programHandle, startsAt: selected.startsAt, endsAt: selected.endsAt }, title: node('title')?.textContent || '', token: token(false), subscription: subscription.toJSON() });
       await refresh();
     }
   } catch(error) {
     if(current===generation) {
       root.dataset.reminderError = error.message || 'unknown';
       if (error.providerStatus) root.dataset.reminderDiagnostic = String(error.providerStatus);
       if (error.message === 'subscription_expired' || error.message === 'subscription_missing') {
         // Audit 24.09.: das tote Abo beim naechsten Einschalten ersetzen, statt es erneut zu schicken.
         try { localStorage.setItem(`${KEY}.reset`, '1'); } catch {}
         await refresh().catch(() => {});
         if (current !== generation) return;
       }
       const messages = {too_late:'tooLate',rate_limited:'rateLimited',subscription_expired:'subscriptionExpired',subscription_missing:'subscriptionExpired',push_unavailable:'pushUnavailable',push_transport_failed:'pushTransportFailed'};
       (testing && node('test-status') || node('status')).textContent=text(messages[error.message] || 'error');
     }
   } finally { if(current===generation) { busy=false; sync(); } }
 });
 document.addEventListener('change', event => {
   if (event.target !== node('mode') || busy) return;
   node('status').textContent = ''; sync();
 });
 // The push worker has a narrow scope; messages explicitly reach this uncontrolled page.
 navigator.serviceWorker?.addEventListener?.('message', event => {
   if (event.data?.type !== 'asif:push-test-received') return;
   try {
     const source = new URL(event.source?.scriptURL);
     if (source.origin !== location.origin || source.pathname !== `${BASE}/sw.js`) return;
   } catch { return; }
   testReceivedAt = Date.now();
   if (dialog?.open && node('test-status')) node('test-status').textContent = text('testReceived');
 });
 document.addEventListener('asif:reminder-open',event=>open(event.detail.item,event.detail.opener));
 const mount=()=>{
   const next=document.querySelector('[data-radio-reminders]'); if(next===root)return;
   dialog?.close(); generation++; busy=false; occurrence=null;
   root=next; dialog=root?.querySelector('dialog'); if(!dialog)return;
   refresh().catch(() => {});
   dialog.addEventListener('close',()=>{generation++;busy=false;if(opener?.isConnected)opener.focus({preventScroll:true});else document.querySelector('#radio-programme-title')?.focus({preventScroll:true});});
 };
 document.addEventListener('asif:page',mount); document.addEventListener('shopify:section:load',mount);
 document.addEventListener('asif:page:unload',()=>{dialog?.close();generation++;root=null;dialog=null;});
 window.addEventListener('storage',event=>{if(event.key===KEY || event.key===null){refreshGeneration++;items=[];series=[];decorate();if(dialog?.open){generation++;dialog.close();}}});
 mount();
})();
